var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{class:_vm.$style.errorCard},[_vm._t("body"),_vm._v(" "),_c('p',[_c('strong',[_vm._v("\n      An unexpected error has occurred. Please close this window and try again.\n    ")])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }